import { array, node, object, oneOfType, string } from 'prop-types';
import React from 'react';

const QuestionBlock = ({ question, answer }) => {
  return (
    <div style={{ padding: '2rem 0 3rem 0' }}>
      <h3 style={{ fontWeight: 400 }}>{question}</h3>
      <div style={{ fontWeight: '600', marginTop: '0.5rem' }}>
        {Array.isArray(answer) ? (
          <ul>
            {answer.map((a, i) => (
              <li key={i}>{a}</li>
            ))}
          </ul>
        ) : answer || answer === 0 ? (
          answer
        ) : (
          '-'
        )}
      </div>
    </div>
  );
};

QuestionBlock.propTypes = {
  question: object,
  answer: oneOfType([string, object, array, node]),
};
export default QuestionBlock;
